(() => {
  'use strict';

  const selectors = {
    variants: '.product__block__variants',
    options: '#avpoptions-container__v2, .avpoptions-container__v2',
    formSelectors: '.form__selectors',
    price: '.product__block__price',
  };

  let frameRequested = false;

  const stabilizeVariantSelectors = () => {
    const options = document.querySelector(selectors.options);
    const variants = document.querySelector(selectors.variants);
    const formSelectors = options?.closest(selectors.formSelectors);

    if (!options || !variants || !formSelectors) return;
    if (!variants.contains(formSelectors)) return;

    formSelectors.setAttribute('data-morph-skip', '');
    formSelectors.setAttribute('data-lb-cambio-selectors-stable', 'true');
    options.removeAttribute('data-morph-skip');
    options.removeAttribute('data-lb-cambio-options-stable');
  };

  const stabilizePrice = () => {
    const price = document.querySelector(selectors.price);
    if (!price) return;

    price.setAttribute('data-morph-skip', '');
    price.setAttribute('data-lb-cambio-price-stable', 'true');
  };

  // Keep the descriptive property in step with the checked options. ARIS still
  // owns add-on variants, prices and bundle links; this only fixes their label.
  const buckleSelection = () => {
    const variants = document.querySelector(selectors.variants);
    const options = variants?.querySelector(selectors.options);
    const form = variants?.querySelector('.radio__fieldset input[form]')?.form;
    if (!options || !form) return null;
    const checked = options.querySelectorAll('input[type="checkbox"][field-name="CAMBIO Schnallen"]:checked');
    return { variants, form, value: Array.from(checked, input => input.value).join(', ') };
  };

  const syncBuckleProperty = () => {
    const selection = buckleSelection();
    if (!selection) return;
    // The variant refresh can remove ARIS's hidden field from the current form.
    // Provide one form-associated property so its bundle builder cannot fall
    // back to the first add-on's name.
    const key = 'properties[CAMBIO Schnallen]';
    let property = Array.from(selection.form.elements).find(input => input.name === key);
    if (!property && selection.value) {
      property = document.createElement('input');
      property.type = 'hidden';
      property.name = key;
      property.setAttribute('data-lb-buckle-property', '');
      selection.form.appendChild(property);
    }
    document.querySelectorAll('input[name="properties[CAMBIO Schnallen]"]').forEach(input => {
      if (input.form !== selection.form && !selection.variants.contains(input)) return;
      if (input.value !== selection.value) input.value = selection.value;
    });
  };

  const syncOptionLegends = () => {
    document.querySelectorAll('.product__block__variants .radio__fieldset').forEach(fieldset => {
      const checked = fieldset.querySelector('input[type="radio"]:checked');
      const label = fieldset.querySelector('.radio__legend [data-option-value]');
      if (checked && label && label.textContent !== checked.value) label.textContent = checked.value;
    });
  };

  const stabilizeAll = () => {
    frameRequested = false;
    stabilizeVariantSelectors();
    stabilizePrice();
    syncOptionLegends();
    syncBuckleProperty();
  };

  const scheduleStabilization = () => {
    if (frameRequested) return;
    frameRequested = true;
    window.requestAnimationFrame(stabilizeAll);
  };

  const observer = new MutationObserver(scheduleStabilization);

  const start = () => {
    scheduleStabilization();
    document.addEventListener('change', scheduleStabilization);
    document.addEventListener('click', event => {
      if (event.target.closest?.('[data-add-to-cart]')) syncBuckleProperty();
    }, true);
    document.addEventListener('formdata', event => {
      const selection = buckleSelection();
      const key = 'properties[CAMBIO Schnallen]';
      if (selection && event.target === selection.form) {
        if (selection.value) event.formData.set(key, selection.value);
        else event.formData.delete(key);
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
    window.addEventListener('theme:section:update', scheduleStabilization);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
